import {colors} from "./colors";
import {views} from "./helpers/views"

/**
 * Configuration of chartjs-plugin-datalabels plugin that displays data on top of bar charts
 *
 * @url https://chartjs-plugin-datalabels.netlify.com/
 * @type {{formatter: dataLabelsConfiguration.formatter, offset: number, color: string, display: boolean, anchor: string, clamp: boolean, font: {size: number}}}
 */
const getDataLabelsConfiguration = (view, fullscreen) => ({
    display: views[view] >= views.week && fullscreen, // display datalabels in week, month and year view in fullscreen mode
    anchor: 'end',
    clamp: true,
    offset: 0,
    color: colors.datalabels,
    font: {
        size: 14,
    },
    formatter: (value, context) => {
        if (typeof(value?.y) !== 'number') {
            return ''
        }

        return value.y < 1 ?
            Math.round(value.y * 1000) / 1000
            : value.y < 10 ?
                Math.round(value.y * 10) / 10 : Math.round(value.y)
    }
})

const getDefaultDataLabelsConfiguration = (datasetIndex) => {
    switch (datasetIndex) {
        case 0:
            return {
                align: '-135',
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: -5
                }
            }
        case 1:
            return {
                align: '-45',
                padding: {
                    top: 0,
                    right: -2,
                    bottom: 0,
                    left: 0
                }
            }
        case 2:
            return {
                align: '-45',
                padding: {
                    top: 0,
                    right: -2,
                    bottom: 0,
                    left: 0
                }
            }
        default: throw new Error(`Unknown dataset index: "${datasetIndex}"`)
    }
}

export {getDataLabelsConfiguration, getDefaultDataLabelsConfiguration}